import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {Annotation, isValidExternalId} from "@cm/template-nodes"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-annotation-inspector",
    templateUrl: "./annotation-inspector.component.html",
    styleUrl: "./annotation-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class AnnotationInspectorComponent extends BaseInspectorComponent<Annotation> {
    readonly $isValidExternalId = signal(isValidExternalId)
}
